import React from 'react';
import { length, includes } from 'ramda';
import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import useScreen from 'hooks/useScreen';
import Loader from 'sharedComponents/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';

import LoanOfficerCard from './components/LoanOfficerCard';
import useStyles from './useStyles';

const LoanOfficersList = props => {
  const {
    loanOfficers,
    isLoading,
    meta,
    onLoadMore,
    onAddFavoriteLoanOfficer,
    isAddingFavoriteLoanOfficer,
    favoriteLoanOfficerIds,
  } = props;
  const { isDesktop } = useScreen();
  const classes = useStyles();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={classes.loaderBox}>
        <Loader />
      </div>
    );
  }

  if (isBlank(loanOfficers)) {
    return (
      <div className={classes.container}>
        <Typography className={classes.emptyLabel} variant="subtitle1">
          {t('components.RealEstateAgentLoanOfficers.LoanOfficersList.noLoanOfficers')}
        </Typography>
      </div>
    );
  }

  const { totalPages, currentPage } = meta;
  const hasMore = currentPage < totalPages;
  const nextPage = currentPage + 1;

  const handleLoadMore = () => {
    onLoadMore({ page: nextPage });
  };

  return (
    <div className={classes.container} id="scrollableDiv" key="scrollableDiv">
      <InfiniteScroll
        dataLength={length(loanOfficers)}
        next={handleLoadMore}
        hasMore={hasMore}
        loader={
          <div>
            {[1, 2, 3].map(key => (
              <div key={key} className={classes.skeletonBox}>
                <Skeleton variant="circle" animation="wave" width={40} height={40} />
                <Skeleton variant="rect" animation="wave" className={classes.skeletonText} />
              </div>
            ))}
          </div>
        }
        scrollableTarget={isDesktop ? 'scrollableDiv' : 'scrollableMainContainer'}
      >
        {loanOfficers.map(({ id, attributes }) => {
          const isFavorite = includes(id, favoriteLoanOfficerIds);
          return (
            <LoanOfficerCard
              key={id}
              loanOfficer={attributes}
              onAdd={onAddFavoriteLoanOfficer}
              isAdding={isAddingFavoriteLoanOfficer}
              isFavorite={isFavorite}
            />
          );
        })}
      </InfiniteScroll>
    </div>
  );
};

LoanOfficersList.propTypes = {
  loanOfficers: PropTypes.arrayOf(PropTypes.shape()),
  isLoading: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  onAddFavoriteLoanOfficer: PropTypes.func.isRequired,
  isAddingFavoriteLoanOfficer: PropTypes.bool.isRequired,
  favoriteLoanOfficerIds: PropTypes.arrayOf(PropTypes.string),
  meta: PropTypes.shape(),
};

LoanOfficersList.defaultProps = {
  loanOfficers: [],
  favoriteLoanOfficerIds: [],
  meta: {},
};

export default LoanOfficersList;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/LoanOfficersList/LoanOfficersList.js